(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    if (window.__alinaCart) return;

    var SEL = {
      drawer: '[data-cart-drawer]',
      inner: '[data-cart-drawer-inner]',
      items: '[data-cart-items]',
      page: '[data-cart-page]',
      bubble: '[data-cart-bubble]',
      open: '[data-cart-open]',
      close: '[data-cart-close]',
      error: '[data-cart-error]'
    };
    var OPEN = 'cart-drawer--open';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var busy = false;
    var pendingClose = null;
    var lastFocused = null;

    function drawer() { return document.querySelector(SEL.drawer); }
    function panel() { var d = drawer(); return d ? d.querySelector('.cart-drawer__panel') : null; }

    function cancelPendingClose() {
      if (!pendingClose) return;
      window.clearTimeout(pendingClose.timer);
      if (pendingClose.panel) pendingClose.panel.removeEventListener('transitionend', pendingClose.finish);
      pendingClose = null;
    }

    /* ---------- open / close ---------- */
    function playIntro() {
      var items = document.querySelector(SEL.items);
      if (!items || reduce) return;
      items.classList.remove('cart-drawer__items--intro');
      void items.offsetWidth;
      items.classList.add('cart-drawer__items--intro');
      window.setTimeout(function () { items.classList.remove('cart-drawer__items--intro'); }, 900);
    }

    function open() {
      var d = drawer();
      if (!d) return;
      cancelPendingClose();
      if (!d.classList.contains(OPEN)) lastFocused = document.activeElement;
      d.removeAttribute('inert');
      d.setAttribute('aria-hidden', 'false');
      // Commit the off-screen start state before flipping to open so the slide
      // always plays from the edge (no jump).
      var p = panel();
      if (p) void p.offsetWidth;
      requestAnimationFrame(function () {
        d.classList.add(OPEN);
        playIntro();
      });
      var closeBtn = d.querySelector('.cart-drawer__close');
      if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch (e) {} }
      document.addEventListener('keydown', onKeydown, true);
    }

    function finalizeClose(d) {
      d.setAttribute('inert', '');
      d.setAttribute('aria-hidden', 'true');
    }

    function restoreFocus() {
      if (lastFocused && lastFocused.focus) { try { lastFocused.focus({ preventScroll: true }); } catch (e) {} }
      lastFocused = null;
    }

    function close() {
      var d = drawer();
      if (!d) return;
      cancelPendingClose();
      document.removeEventListener('keydown', onKeydown, true);
      if (!d.classList.contains(OPEN)) { finalizeClose(d); return; }
      d.classList.remove(OPEN);
      var afterClose = function () { finalizeClose(d); restoreFocus(); };
      if (reduce) { afterClose(); return; }
      var p = panel();
      var done = false;
      var finish = function (e) {
        if (e && e.target !== p) return;
        if (done) return;
        done = true;
        cancelPendingClose();
        afterClose();
      };
      if (p) p.addEventListener('transitionend', finish);
      pendingClose = { panel: p, finish: finish, timer: window.setTimeout(finish, 600) };
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.keyCode === 27) { e.preventDefault(); close(); return; }
      if (e.key === 'Tab' || e.keyCode === 9) { trapFocus(e); }
    }

    function trapFocus(e) {
      var d = drawer();
      if (!d) return;
      var nodes = d.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])');
      var f = [];
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement) f.push(el);
      }
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus({ preventScroll: true }); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus({ preventScroll: true }); }
    }

    /* ---------- section rendering ---------- */
    function sectionsParam() {
      var ids = [];
      document.querySelectorAll('[data-section-id]').forEach(function (el) {
        if (el.matches(SEL.drawer) || el.matches(SEL.page)) {
          var id = el.getAttribute('data-section-id');
          if (id && ids.indexOf(id) === -1) ids.push(id);
        }
      });
      return ids.join(',');
    }

    function applySections(sections) {
      if (!sections) { return refreshCount(); }
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (typeof html !== 'string') return;
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var freshInner = doc.querySelector(SEL.inner);
        var liveInner = document.querySelector(SEL.inner);
        if (freshInner && liveInner) liveInner.innerHTML = freshInner.innerHTML;

        var freshPage = doc.querySelector(SEL.page);
        var livePage = document.querySelector(SEL.page);
        if (freshPage && livePage) livePage.innerHTML = freshPage.innerHTML;

        var freshDrawer = doc.querySelector(SEL.drawer);
        if (freshDrawer) {
          var d = drawer();
          if (d) d.setAttribute('data-cart-count', freshDrawer.getAttribute('data-cart-count') || '0');
        }
      });
      syncBubble();
    }

    function syncBubble(count) {
      if (count == null) {
        var d = drawer();
        count = d ? parseInt(d.getAttribute('data-cart-count'), 10) : 0;
      }
      if (isNaN(count)) count = 0;
      document.querySelectorAll(SEL.bubble).forEach(function (b) {
        b.textContent = count;
        if (count > 0) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden', ''); }
        if (!reduce) {
          b.classList.remove('is-pop');
          void b.offsetWidth;
          b.classList.add('is-pop');
        }
      });
    }

    function refreshCount() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var d = drawer();
          if (d) d.setAttribute('data-cart-count', c.item_count);
          syncBubble(c.item_count);
        })
        .catch(function () {});
    }

    /* ---------- button states ---------- */
    function setLoading(btn, on) {
      if (!btn) return;
      if (on) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      else { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    }

    function flashSuccess(btn) {
      if (!btn) return;
      btn.classList.add('is-success');
      window.setTimeout(function () { btn.classList.remove('is-success'); }, 1100);
    }

    function clearErrors() {
      document.querySelectorAll(SEL.error).forEach(function (n) { n.textContent = ''; });
    }

    function showError(scopeEl, msg) {
      var text = msg || 'Something went wrong. Please try again.';
      var d = drawer();
      if (d && d.classList.contains(OPEN)) {
        var live = d.querySelector(SEL.error);
        if (live) { live.textContent = text; return; }
      }
      if (scopeEl) {
        var page = scopeEl.closest(SEL.page);
        if (page) {
          var pe = page.querySelector(SEL.error);
          if (pe) { pe.textContent = text; return; }
        }
        var form = scopeEl.closest('form') || scopeEl.parentElement;
        if (!form) return;
        var node = form.querySelector('.cart-inline-error');
        if (!node) {
          node = document.createElement('div');
          node.className = 'cart-inline-error';
          node.setAttribute('role', 'alert');
          node.style.cssText = 'color:#9C6040;font-size:0.8125rem;line-height:1.4;margin-top:0.6rem;text-align:center;';
          form.appendChild(node);
        }
        node.textContent = text;
        window.setTimeout(function () { if (node) node.textContent = ''; }, 4000);
      }
    }

    /* ---------- mutations ---------- */
    function addFromForm(form, submitter) {
      if (busy) return;
      busy = true;
      clearErrors();
      var btn = submitter || form.querySelector('[type="submit"], button:not([type])');
      setLoading(btn, true);

      var fd = new FormData(form);
      /* A blank selling_plan is the product form's "one-time purchase" choice. The Ajax
         API documents omitting the field for one-time; a blank value is undocumented, so
         drop it rather than posting it. */
      if (fd.get('selling_plan') === '') fd.delete('selling_plan');
      var sp = sectionsParam();
      if (sp) { fd.append('sections', sp); fd.append('sections_url', window.location.pathname); }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw res.data;
          if (res.data.sections) { applySections(res.data.sections); } else { refreshCount(); }
          setLoading(btn, false);
          flashSuccess(btn);
          open();
        })
        .catch(function (err) {
          setLoading(btn, false);
          showError(btn, err && (err.description || err.message));
        })
        .then(function () { busy = false; });
    }

    function change(key, qty, lineEl) {
      if (busy || !key) return;
      busy = true;
      clearErrors();
      if (lineEl) lineEl.setAttribute('data-line-busy', '');

      var run = function () {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ id: key, quantity: qty, sections: sectionsParam(), sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) throw res.data;
            if (res.data.sections) { applySections(res.data.sections); } else { refreshCount(); }
          })
          .catch(function (err) {
            if (lineEl) lineEl.removeAttribute('data-line-busy');
            showError(lineEl, err && (err.description || err.message));
          })
          .then(function () { busy = false; });
      };

      if (qty <= 0 && lineEl && !reduce) {
        lineEl.classList.add('cart-line--removing');
        window.setTimeout(run, 260);
      } else {
        run();
      }
    }

    /* ---------- events ---------- */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('form[action$="/cart/add"]')) return;
      if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
      e.preventDefault();
      addFromForm(form, e.submitter);
    }, true);

    document.addEventListener('click', function (e) {
      if (e.target.closest(SEL.open)) { e.preventDefault(); open(); return; }
      if (e.target.closest(SEL.close)) { e.preventDefault(); close(); return; }
      /* In-page links (the empty cart's Continue shopping → #shop) are scrolled or
         navigated by the header's [data-scroll-link] handler, so leave the default
         alone; just get the drawer out of the way without pulling focus back to the
         cart button once the scroll lands. */
      if (e.target.closest(SEL.drawer + ' [data-scroll-link]')) { lastFocused = null; close(); return; }

      var step = e.target.closest('[data-line-change]');
      if (step) {
        e.preventDefault();
        change(step.getAttribute('data-line-key'), parseInt(step.getAttribute('data-qty'), 10), step.closest('[data-line-item]'));
        return;
      }
      var rem = e.target.closest('[data-line-remove]');
      if (rem) {
        e.preventDefault();
        change(rem.getAttribute('data-line-key'), 0, rem.closest('[data-line-item]'));
        return;
      }
    });

    window.__alinaCart = {
      open: open, close: close, change: change, addFromForm: addFromForm, refresh: refreshCount
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    if (window.__alinaStickyHeader) return;
    window.__alinaStickyHeader = true;

    var STUCK = 'is-stuck';
    var THRESHOLD = 2;
    var el = null;
    var ticking = false;

    /* Re-queried when detached so the theme editor's section re-render keeps working. */
    function header() {
      if (!el || !el.isConnected) el = document.getElementById('shopify-section-header');
      return el;
    }

    function apply() {
      ticking = false;
      var node = header();
      if (!node) return;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      node.classList.toggle(STUCK, y > THRESHOLD);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('shopify:section:load', onScroll);

    apply();
  })();

  /* ---------- in-page scroll targets (Shop, Our Foundation) ---------- */
  (function () {
    if (window.__alinaScrollLinks) return;
    window.__alinaScrollLinks = true;

    var FLAG = 'alina:scroll-to';
    var LOAD_FALLBACK_MS = 1500;
    var IMAGE_WAIT_MS = 1200;
    var DURATION = 700;
    var HOLD_MS = 600;

    function reduced() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function scrollTop() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    /* scroll-margin-top on the target carries the sticky header's height, so the same
       value is used here rather than hard-coding a header offset that would drift. */
    function destination(el) {
      var margin = parseFloat(window.getComputedStyle(el).scrollMarginTop);
      if (isNaN(margin)) margin = 0;
      var y = el.getBoundingClientRect().top + scrollTop() - margin;
      var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      return Math.min(Math.max(0, y), max);
    }

    /* Lazy images ABOVE the target are the accuracy problem: they are not covered by the
       load event and only fetch as they near the viewport, so they resolve mid-travel and
       push the target further down. Promote them to eager and wait for them to finish
       (bounded) before moving. */
    function settleAbove(el, done) {
      var nodes = document.querySelectorAll('img[loading="lazy"]');
      var pending = [];
      for (var i = 0; i < nodes.length; i++) {
        var img = nodes[i];
        if (!(el.compareDocumentPosition(img) & Node.DOCUMENT_POSITION_PRECEDING)) continue;
        img.loading = 'eager';
        if (!img.complete) pending.push(img);
      }
      if (!pending.length) { done(); return; }

      var remaining = pending.length;
      var settled = false;
      function finish() {
        if (settled) return;
        settled = true;
        done();
      }
      function tick() { if (--remaining <= 0) finish(); }
      for (var j = 0; j < pending.length; j++) {
        pending[j].addEventListener('load', tick, { once: true });
        pending[j].addEventListener('error', tick, { once: true });
      }
      /* A stalled image must never strand the click. */
      window.setTimeout(finish, IMAGE_WAIT_MS);
    }

    /* Hold the landing briefly. Anything that resolves just after we arrive — an image
       that finished a moment late, a font swap, the sticky header settling — would
       otherwise leave the section sitting above or below where it belongs. Re-asserts
       the position until it agrees for several frames, and yields the moment the visitor
       scrolls for themselves. */
    function hold(el, done) {
      var started = null;
      var agreed = 0;
      var released = false;

      function stop() {
        if (released) return;
        released = true;
        window.removeEventListener('wheel', stop);
        window.removeEventListener('touchstart', stop);
        window.removeEventListener('keydown', stop);
        if (done) done();
      }

      window.addEventListener('wheel', stop, { passive: true });
      window.addEventListener('touchstart', stop, { passive: true });
      window.addEventListener('keydown', stop);

      function frame(now) {
        if (released) return;
        if (started === null) started = now;
        var want = destination(el);
        if (Math.abs(scrollTop() - want) > 1) {
          window.scrollTo(0, want);
          agreed = 0;
        } else {
          agreed++;
        }
        if (agreed >= 5 || now - started > HOLD_MS) { stop(); return; }
        window.requestAnimationFrame(frame);
      }

      window.requestAnimationFrame(frame);
    }

    function travel(el, done) {
      if (reduced()) {
        /* No animation, but the same correction: accuracy is not a motion preference. */
        window.scrollTo(0, destination(el));
        hold(el, done);
        return;
      }

      var from = scrollTop();
      var began = null;
      var aborted = false;

      function release() {
        window.removeEventListener('wheel', abort);
        window.removeEventListener('touchstart', abort);
        window.removeEventListener('keydown', abort);
      }
      function abort() { aborted = true; release(); }

      window.addEventListener('wheel', abort, { passive: true });
      window.addEventListener('touchstart', abort, { passive: true });
      window.addEventListener('keydown', abort);

      function frame(now) {
        if (aborted) return;
        if (began === null) began = now;
        var t = Math.min(1, (now - began) / DURATION);
        var eased = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        /* Re-read the destination every frame so anything that shifts underneath us —
           a late image, a font swap, a section resizing — is corrected as we go. */
        window.scrollTo(0, from + (destination(el) - from) * eased);
        if (t < 1) {
          window.requestAnimationFrame(frame);
          return;
        }
        release();
        window.scrollTo(0, destination(el));
        hold(el, done);
      }

      window.requestAnimationFrame(frame);
    }

    function land(el) {
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
      try { el.focus({ preventScroll: true }); } catch (e) {}
    }

    function goTo(el) {
      settleAbove(el, function () {
        travel(el, function () { land(el); });
      });
    }

    function remember(id) {
      try { window.sessionStorage.setItem(FLAG, id); return true; } catch (e) { return false; }
    }

    function consume() {
      try {
        var id = window.sessionStorage.getItem(FLAG);
        if (id) window.sessionStorage.removeItem(FLAG);
        return id;
      } catch (e) { return null; }
    }

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; /* new tab/window */
      var link = e.target && e.target.closest ? e.target.closest('[data-scroll-link]') : null;
      if (!link) return;

      var id = link.getAttribute('data-scroll-link');
      var el = id ? document.getElementById(id) : null;

      /* Already on a page that holds the target — travel, never reload. */
      if (el) {
        e.preventDefault();
        goTo(el);
        return;
      }

      /* Going home: carry the intent in sessionStorage and drop the fragment, so the
         browser cannot hard-jump to the anchor before we get to animate. Without storage
         the plain href still lands in the right place. */
      if (remember(id)) {
        e.preventDefault();
        window.location.href = link.href.split('#')[0];
      }
    }, false);

    function whenSettled(fn) {
      var done = false;
      function go() {
        if (done) return;
        done = true;
        window.requestAnimationFrame(function () { window.requestAnimationFrame(fn); });
      }
      if (document.readyState === 'complete') { go(); return; }
      window.addEventListener('load', go);
      window.setTimeout(go, LOAD_FALLBACK_MS);
    }

    function init() {
      var id = consume();
      if (!id) return;
      whenSettled(function () {
        var el = document.getElementById(id);
        if (el) goTo(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  /* ---------- mobile navigation ---------- */
  (function () {
    if (window.__alinaMobileMenu) return;
    window.__alinaMobileMenu = true;

    var OPEN = 'mobile-menu--open';
    var CLOSING = 'mobile-menu--closing';
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var lastFocused = null;
    var scrollLocked = false;
    var prevOverflow = '';
    var prevPadding = '';
    var closeTimer = null;

    function menu() { return document.querySelector('[data-mobile-menu]'); }
    function toggle() { return document.querySelector('[data-menu-toggle]'); }
    function panel(el) { return el ? el.querySelector('.mobile-menu__panel') : null; }
    function isOpen() { var el = menu(); return !!el && el.classList.contains(OPEN); }

    function lockScroll() {
      if (scrollLocked) return;
      var docEl = document.documentElement;
      var bar = window.innerWidth - docEl.clientWidth;
      prevOverflow = docEl.style.overflow;
      prevPadding = document.body.style.paddingRight;
      docEl.style.overflow = 'hidden';
      if (bar > 0) {
        var current = parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
        document.body.style.paddingRight = current + bar + 'px';
      }
      scrollLocked = true;
    }

    function unlockScroll() {
      if (!scrollLocked) return;
      document.documentElement.style.overflow = prevOverflow;
      document.body.style.paddingRight = prevPadding;
      scrollLocked = false;
    }

    function focusables(el) {
      var nodes = el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      var out = [];
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].offsetWidth > 0 || nodes[i].offsetHeight > 0) out.push(nodes[i]);
      }
      return out;
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab' && e.keyCode !== 9) return;
      var el = menu();
      if (!el) return;
      var list = focusables(el);
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (!el.contains(document.activeElement)) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus({ preventScroll: true });
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus({ preventScroll: true });
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus({ preventScroll: true });
      }
    }

    function open() {
      var el = menu();
      if (!el || el.classList.contains(OPEN)) return;
      if (closeTimer) { window.clearTimeout(closeTimer); closeTimer = null; }
      el.classList.remove(CLOSING);
      lastFocused = document.activeElement;
      el.removeAttribute('inert');
      el.setAttribute('aria-hidden', 'false');

      var p = panel(el);
      if (p) void p.offsetWidth;   /* commit the off-screen start so the slide always plays */

      window.requestAnimationFrame(function () {
        var current = menu();
        if (!current) return;
        current.classList.add(OPEN);
        var list = focusables(current);
        if (list.length) { try { list[0].focus({ preventScroll: true }); } catch (e) {} }
      });

      var btn = toggle();
      if (btn) btn.setAttribute('aria-expanded', 'true');
      lockScroll();
      document.addEventListener('keydown', onKeydown, true);
    }

    function close() {
      var el = menu();
      if (!el) return;
      document.removeEventListener('keydown', onKeydown, true);
      var wasOpen = el.classList.contains(OPEN);
      el.classList.remove(OPEN);
      el.setAttribute('inert', '');
      el.setAttribute('aria-hidden', 'true');
      var btn = toggle();
      if (btn) btn.setAttribute('aria-expanded', 'false');
      unlockScroll();

      if (lastFocused && lastFocused.focus && lastFocused.isConnected) {
        try { lastFocused.focus({ preventScroll: true }); } catch (e) {}
      }
      lastFocused = null;

      /* Visibility is class driven rather than transition driven, so a throttled frame
         can never leave the panel reachable by tab. */
      if (!wasOpen || reduce) { el.classList.remove(CLOSING); return; }
      el.classList.add(CLOSING);
      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        closeTimer = null;
        var current = menu();
        if (current && !current.classList.contains(OPEN)) current.classList.remove(CLOSING);
      }, 500);
    }

    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      if (target.closest('[data-menu-toggle]')) {
        e.preventDefault();
        if (isOpen()) close(); else open();
        return;
      }
      if (!isOpen()) return;
      if (target.closest('[data-menu-close]')) { e.preventDefault(); close(); return; }
      /* Closing before the link acts matters: an in-page scroll link cannot move the
         page while the menu still holds the scroll lock. */
      if (target.closest('.mobile-menu__link')) close();
    }, false);

    /* A resize up to the desktop bar leaves the panel stranded otherwise. */
    window.addEventListener('resize', function () {
      if (!isOpen()) return;
      var btn = toggle();
      if (btn && !btn.offsetParent) close();
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["levels"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.levels .lvl__item').forEach(function (item) {
    var head = item.querySelector('.lvl__head');
    if (!head) return;
    head.addEventListener('click', function () {
      var isOpen = item.classList.contains('lvl__item--open');
      var list = item.closest('.lvl__list');
      if (list) {
        list.querySelectorAll('.lvl__item--open').forEach(function (open) {
          open.classList.remove('lvl__item--open');
          var openHead = open.querySelector('.lvl__head');
          if (openHead) openHead.setAttribute('aria-expanded', 'false');
        });
      }
      if (!isOpen) {
        item.classList.add('lvl__item--open');
        head.setAttribute('aria-expanded', 'true');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function () {
    if (window.__alinaNewsletterPopup) return;
    window.__alinaNewsletterPopup = true;

    var OPEN = 'nlp--open';
    var CLOSING = 'nlp--closing';
    var STORAGE_KEY = 'alina:newsletter-popup';
    var DAY_MS = 86400000;
    var CART_RETRY_MS = 1500;
    var CART_RETRY_MAX = 20;
    var SUCCESS_CLOSE_MS = 3600;
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var pendingClose = null;
    var timer = null;
    var cartRetries = 0;
    var lastFocused = null;
    var pending = false;
    var wantOpen = false;
    var scrollLocked = false;
    var prevRootOverflow = '';
    var prevBodyPadding = '';
    /* Fallback when localStorage throws (Safari private mode, blocked cookies): the
       popup then behaves as "once per page load" instead of breaking. */
    var memoryState = null;

    function cancelPendingClose() {
      if (!pendingClose) return;
      window.clearTimeout(pendingClose.timer);
      if (pendingClose.panel) pendingClose.panel.removeEventListener('transitionend', pendingClose.finish);
      pendingClose = null;
    }

    function root() {
      return document.querySelector('[data-nlp]');
    }

    function q(el, selector) {
      return el ? el.querySelector(selector) : null;
    }

    /* ---------- suppression memory ---------- */
    function readState() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        if (raw) {
          var parsed = JSON.parse(raw);
          if (parsed && typeof parsed === 'object') return parsed;
        }
      } catch (e) {}
      return memoryState;
    }

    function writeState(status) {
      var state = { status: status, at: Date.now() };
      memoryState = state;
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (e) {}
    }

    function suppressed(el) {
      /* In the theme editor the merchant always needs to see it. */
      if (designMode) return false;
      var state = readState();
      if (!state || !state.status) return false;
      if (state.status === 'subscribed') return true;
      if (state.status !== 'dismissed') return false;

      var days = parseFloat(el.getAttribute('data-dismiss-days'));
      if (!(days > 0)) days = 30;
      var at = typeof state.at === 'number' ? state.at : 0;
      var elapsed = Date.now() - at;
      /* A future timestamp means a clock change — treat it as "just dismissed". */
      if (elapsed < 0) return true;
      return elapsed < days * DAY_MS;
    }

    /* ---------- scroll lock ---------- */
    function lockScroll() {
      if (scrollLocked) return;
      var docEl = document.documentElement;
      var barWidth = window.innerWidth - docEl.clientWidth;
      prevRootOverflow = docEl.style.overflow;
      prevBodyPadding = document.body.style.paddingRight;
      docEl.style.overflow = 'hidden';
      if (barWidth > 0) {
        var current = parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
        document.body.style.paddingRight = current + barWidth + 'px';
      }
      scrollLocked = true;
    }

    function unlockScroll() {
      if (!scrollLocked) return;
      document.documentElement.style.overflow = prevRootOverflow;
      document.body.style.paddingRight = prevBodyPadding;
      scrollLocked = false;
    }

    /* ---------- open / close ---------- */
    function isOpen() {
      var el = root();
      return !!el && el.classList.contains(OPEN);
    }

    function open() {
      var el = root();
      if (!el || el.classList.contains(OPEN)) return;
      clearTimer();

      wantOpen = true;
      cancelPendingClose();
      el.classList.remove(CLOSING);
      lastFocused = document.activeElement;
      el.removeAttribute('inert');
      el.setAttribute('aria-hidden', 'false');

      /* Commit the closed transform before flipping to open so the entrance always
         plays from the start state instead of jumping. */
      var panel = q(el, '.nlp__panel');
      if (panel) void panel.offsetWidth;

      window.requestAnimationFrame(function () {
        var current = root();
        /* A close in the same frame wins — otherwise this would re-open an
           already-dismissed popup and leave it inert. */
        if (!current || !wantOpen) return;
        current.classList.add(OPEN);
        /* Focus only once the panel is actually visible — focus() is a no-op on a
           visibility: hidden element, which would leave keyboard users outside. */
        focusFirst(current);
      });

      lockScroll();
      document.addEventListener('keydown', onKeydown, true);
    }

    function focusFirst(el) {
      var target = q(el, '.nlp__close') || focusable(el)[0];
      if (!target) return;
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    }

    /* reason: 'dismissed' remembers the choice, anything else just closes. */
    function close(reason) {
      var el = root();
      if (!el) return;
      wantOpen = false;
      clearTimer();
      document.removeEventListener('keydown', onKeydown, true);
      el.classList.remove(OPEN);
      el.classList.add(CLOSING);
      el.setAttribute('inert', '');
      el.setAttribute('aria-hidden', 'true');
      unlockScroll();
      if (reason === 'dismissed') writeState('dismissed');
      restoreFocus();
      finishClose(el);
    }

    /* Drop .nlp--closing once the panel has animated out — on transitionend, or on a
       timer if the transition never fires (reduced motion, a throttled tab). */
    function finishClose(el) {
      cancelPendingClose();
      var panel = q(el, '.nlp__panel');
      var done = false;
      var finish = function (e) {
        if (e && e.target !== panel) return;
        if (done) return;
        done = true;
        cancelPendingClose();
        var current = root();
        if (current && !current.classList.contains(OPEN)) current.classList.remove(CLOSING);
      };
      if (reduce || !panel) { finish(); return; }
      panel.addEventListener('transitionend', finish);
      pendingClose = { panel: panel, finish: finish, timer: window.setTimeout(finish, 700) };
    }

    function restoreFocus() {
      var target = lastFocused;
      lastFocused = null;
      if (!target || typeof target.focus !== 'function' || !target.isConnected) return;
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    }

    function onKeydown(e) {
      var key = e.key;
      if (key === 'Escape' || key === 'Esc' || e.keyCode === 27) {
        e.preventDefault();
        close('dismissed');
        return;
      }
      if (key === 'Tab' || e.keyCode === 9) trapFocus(e);
    }

    function focusable(el) {
      var nodes = el.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      var list = [];
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (node.offsetWidth > 0 || node.offsetHeight > 0 || node === document.activeElement) {
          list.push(node);
        }
      }
      return list;
    }

    function focusInto(e, node) {
      if (!node) return;
      e.preventDefault();
      try { node.focus({ preventScroll: true }); } catch (err) { node.focus(); }
    }

    function trapFocus(e) {
      var el = root();
      if (!el) return;
      var list = focusable(el);
      if (!list.length) return;

      var first = list[0];
      var last = list[list.length - 1];

      /* Focus escaped the dialog (or never entered it) — pull it back in. */
      if (!el.contains(document.activeElement)) {
        focusInto(e, e.shiftKey ? last : first);
        return;
      }
      if (e.shiftKey && document.activeElement === first) focusInto(e, last);
      else if (!e.shiftKey && document.activeElement === last) focusInto(e, first);
    }

    /* ---------- trigger ---------- */
    function clearTimer() {
      if (timer === null) return;
      window.clearTimeout(timer);
      timer = null;
    }

    function schedule() {
      var el = root();
      if (!el || isOpen()) return;
      clearTimer();
      cartRetries = 0;
      if (suppressed(el)) return;

      var delay = parseFloat(el.getAttribute('data-delay'));
      if (!(delay >= 0)) delay = 6;
      timer = window.setTimeout(maybeOpen, delay * 1000);
    }

    function maybeOpen() {
      timer = null;
      var el = root();
      if (!el || suppressed(el)) return;

      /* Wait for a background tab to come forward so the entrance is actually seen. */
      if (document.hidden) {
        document.addEventListener('visibilitychange', onVisibilityChange);
        return;
      }

      /* Never fight the cart drawer for the screen. */
      if (document.querySelector('.cart-drawer--open')) {
        if (cartRetries >= CART_RETRY_MAX) return;
        cartRetries++;
        timer = window.setTimeout(maybeOpen, CART_RETRY_MS);
        return;
      }

      open();
    }

    function onVisibilityChange() {
      if (document.hidden) return;
      document.removeEventListener('visibilitychange', onVisibilityChange);
      maybeOpen();
    }

    /* ---------- signup ---------- */
    function showError(el, message) {
      var errorEl = q(el, '.nlp__error');
      var input = q(el, '.nlp__input');
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }
      if (input) input.classList.add('is-invalid');
    }

    function clearError(el) {
      var errorEl = q(el, '.nlp__error');
      var input = q(el, '.nlp__input');
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      if (input) input.classList.remove('is-invalid');
    }

    function setLoading(el, loading) {
      var button = q(el, '.nlp__submit');
      if (!button) return;
      button.classList.toggle('is-loading', loading);
      button.disabled = loading;
    }

    function finishSuccess(el) {
      var form = q(el, '.nlp__form');
      var micro = q(el, '.nlp__micro');
      var success = q(el, '.nlp__success');

      clearError(el);
      if (form) form.hidden = true;
      if (micro) micro.hidden = true;
      if (success) {
        success.hidden = false;
        try { success.focus({ preventScroll: true }); } catch (e) {}
      }

      writeState('subscribed');
      window.setTimeout(function () { close('subscribed'); }, SUCCESS_CLOSE_MS);
    }

    function onSubmit(e) {
      var el = root();
      if (!el) return;
      e.preventDefault();
      if (pending) return;

      var form = q(el, '.nlp__form');
      var input = q(el, '.nlp__input');
      if (!form || !input) return;

      var email = input.value.trim();
      if (!EMAIL_RE.test(email)) {
        showError(el, 'Please enter a valid email address.');
        try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
        return;
      }

      clearError(el);
      setLoading(el, true);
      pending = true;

      /* Captcha is disabled for these forms, so a plain fetch POST works with no
         token. Shopify redirects a successful customer form to ?customer_posted=true
         and fetch follows the redirect, so response.url tells us the outcome. */
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' }
      })
        .then(function (response) {
          pending = false;
          if (response.ok && response.url && response.url.indexOf('customer_posted=true') !== -1) {
            finishSuccess(el);
            return;
          }
          setLoading(el, false);
          showError(el, 'Something went wrong. Please try again.');
        })
        .catch(function () {
          pending = false;
          setLoading(el, false);
          showError(el, 'Network error. Please try again.');
        });
    }

    /* ---------- wiring ---------- */
    function onDocumentClick(e) {
      var target = e.target;
      if (!target || typeof target.closest !== 'function') return;
      if (!isOpen()) return;
      if (target.closest('[data-nlp-close]')) {
        e.preventDefault();
        close('dismissed');
      }
    }

    function onDocumentSubmit(e) {
      var target = e.target;
      if (!target || typeof target.closest !== 'function') return;
      if (!target.closest('[data-nlp]')) return;
      onSubmit(e);
    }

    function onDocumentInput(e) {
      var target = e.target;
      if (!target || !target.classList || !target.classList.contains('nlp__input')) return;
      var el = root();
      if (el) clearError(el);
    }

    function init() {
      var el = root();
      if (!el) return;

      /* Refuse to run without our stylesheet. Without position: fixed this overlay
         renders inline after the footer, and opening it would lock page scroll on a
         static element — exactly what happened when Shopify's subsetted section
         stylesheet omitted this file. Fail closed instead. */
      if (window.getComputedStyle(el).position !== 'fixed') return;
      el.style.display = '';

      /* Our own validation and messaging instead of the browser's bubbles. */
      var form = q(el, '.nlp__form');
      if (form) form.noValidate = true;

      schedule();
    }

    /* Delegated so the theme editor can re-render the section without rebinding. */
    document.addEventListener('click', onDocumentClick, false);
    document.addEventListener('submit', onDocumentSubmit, false);
    document.addEventListener('input', onDocumentInput, false);

    if (designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        if (e.target && e.target.querySelector('[data-nlp]')) init();
      });
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target && e.target.querySelector('[data-nlp]')) open();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target && e.target.querySelector('[data-nlp]')) close('preview');
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waitlist-popup"]) return;
  try {
    
  (function () {
    if (window.__alinaWaitlistPopup) return;
    window.__alinaWaitlistPopup = true;

    var OPEN = 'wl-pop--open';
    var KEY_DISMISSED = 'alina_waitlist_dismissed';
    var KEY_JOINED = 'alina_waitlist_joined';
    var SUPPRESS_DAYS = 30;
    var AUTO_OPEN_MS = 15000;
    var lastFocused = null;
    var closeTimer = null;
    var shown = false;

    function pop() { return document.querySelector('[data-waitlist-popup]'); }

    function isLive() {
      try { return !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role === 'main'); }
      catch (e) { return false; }
    }

    function read(key) {
      try { return window.localStorage.getItem(key); } catch (e) { return null; }
    }

    function write(key, value) {
      try { window.localStorage.setItem(key, value); } catch (e) {}
    }

    /* On the live site the popup remembers who joined or closed it, for 30 days. In a theme preview it
       always shows, so reviewers can see it every time. */
    function suppressed() {
      if (!isLive()) return false;
      if (read(KEY_JOINED)) return true;
      var stamp = parseInt(read(KEY_DISMISSED) || '0', 10);
      return !!stamp && (Date.now() - stamp) < SUPPRESS_DAYS * 86400000;
    }

    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var el = pop();
      if (!el) return;
      var nodes = el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      var list = [];
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].offsetWidth > 0 || nodes[i].offsetHeight > 0) list.push(nodes[i]);
      }
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (!el.contains(document.activeElement)) {
        e.preventDefault(); first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }

    function open() {
      var el = pop();
      if (!el || el.classList.contains(OPEN)) return;
      if (closeTimer) { window.clearTimeout(closeTimer); closeTimer = null; }
      shown = true;
      lastFocused = document.activeElement;
      el.hidden = false;
      el.setAttribute('aria-hidden', 'false');
      void el.offsetWidth; /* commit the off-screen start so the slide always plays */
      el.classList.add(OPEN);
      document.documentElement.style.overflow = 'hidden';
      var panel = el.querySelector('.wl-pop__panel');
      window.setTimeout(function () { if (panel) panel.focus({ preventScroll: true }); }, 60);
      document.addEventListener('keydown', onKey, true);
    }

    function close() {
      var el = pop();
      if (!el || !el.classList.contains(OPEN)) return;
      el.classList.remove(OPEN);
      el.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey, true);
      if (!read(KEY_JOINED)) write(KEY_DISMISSED, String(Date.now()));
      if (lastFocused && lastFocused.focus && lastFocused.isConnected) {
        try { lastFocused.focus({ preventScroll: true }); } catch (e) {}
      }
      closeTimer = window.setTimeout(function () { el.hidden = true; closeTimer = null; }, 500);
    }

    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      if (target.closest('[data-waitlist-open]')) {
        e.preventDefault();
        /* A product page that already shows the waitlist box scrolls to it. Anywhere else opens the popup. */
        var box = document.getElementById('waitlist');
        if (box) {
          box.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var field = box.querySelector('input[type="email"]');
          if (field) window.setTimeout(function () { field.focus({ preventScroll: true }); }, 550);
        } else {
          open();
        }
        return;
      }

      if (target.closest('[data-waitlist-close]')) { e.preventDefault(); close(); }
    }, false);

    document.addEventListener('waitlist:joined', function () {
      var panel = document.querySelector('.wl-pop__panel');
      if (panel) panel.classList.add('is-done');
    });

    function init() {
      var el = pop();
      if (!el) return;

      /* ?waitlist=1 opens the popup straight away and ignores the already-seen memory. */
      var params = new URLSearchParams(window.location.search);
      if (params.get('waitlist') === '1') {
        window.setTimeout(open, 700);
        return;
      }

      var inEditor = !!(window.Shopify && window.Shopify.designMode);
      if (inEditor || suppressed()) return;
      /* Auto-open on the home page only. Elsewhere it opens only from the announcement bar link. */
      if (window.location.pathname !== '/') return;

      window.setTimeout(function () { if (!shown && !suppressed()) open(); }, AUTO_OPEN_MS);

      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        document.addEventListener('mouseout', function (e) {
          if (shown || e.relatedTarget || e.clientY > 0) return;
          if (!suppressed()) open();
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
